import React from 'react';
import { Outlet } from 'react-router-dom';

const SingleTypewriterLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default SingleTypewriterLayout;
